import { BaseModel } from "@blue-chip/core";
import Spec from "./Spec";

export default class Requirement extends BaseModel {
  static get belongsTo() {
    return [Spec];
  }
}
